module.exports = __webpack_public_path__ + "static/img/brees-2007-slide-6.138f6a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-slide-6.jpg
// module id = gXsi
// module chunks = 1